var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-navigation"},[_c('router-link',{staticClass:"the-navigation__link",attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{staticClass:"the-navigation__link",attrs:{"to":"/projects"}},[_vm._v("Projects")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }